document.addEventListener('DOMContentLoaded', () => {
	const ctaLinks = document.querySelectorAll('.cta-block__text a[href^="#"]');

	if (!ctaLinks.length) {
		return;
	}

	ctaLinks.forEach((link) => {
		link.addEventListener('click', (event) => {
			const href = link.getAttribute('href');

			if (!href || href === '#') {
				return;
			}

			const targetId = href.slice(1);
			const target = document.getElementById(targetId);

			if (!target) {
				return;
			}

			event.preventDefault();

			target.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		});
	});
});